import { SecurityAccessEnum } from './security-access-enum';
import { RestrictedFunctionTypeEnum } from './restricted-function-type-enum';

export class RestrictedFunction {
  description: string;
  restrictedFunctionId: number;
  restrictedFunctionName: RestrictedFunctionTypeEnum;
  securityAccess: SecurityAccessEnum;
}
